import { render, staticRenderFns } from "./MyDormServices.vue?vue&type=template&id=dd9f29c2&scoped=true&"
import script from "./MyDormServices.vue?vue&type=script&lang=js&"
export * from "./MyDormServices.vue?vue&type=script&lang=js&"
import style0 from "./MyDormServices.vue?vue&type=style&index=0&id=dd9f29c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd9f29c2",
  null
  
)

export default component.exports